__turbopack_context__.v({
  "container": "styles-module__6H_HBq__container",
  "counter": "styles-module__6H_HBq__counter",
  "counterLarge": "styles-module__6H_HBq__counterLarge",
  "counterMiddle": "styles-module__6H_HBq__counterMiddle",
  "counterSmall": "styles-module__6H_HBq__counterSmall",
  "title": "styles-module__6H_HBq__title",
});
